import { request } from '../http';

export type FeatureFlagKey =
  | 'marketplace'
  | 'customer_billing'
  | 'stripe'
  | 'telegram'
  | 'telethon'
  | 'maintenance'
  | 'experimental_scrapers'
  | 'future_ai_templates';

export type EffectiveFeatureFlagsResponse = {
  flags: Record<
    FeatureFlagKey,
    {
      enabled: boolean;
      source: string;
    }
  >;
};

export const featureFlagService = {
  effective(): Promise<EffectiveFeatureFlagsResponse> {
    return request<EffectiveFeatureFlagsResponse>('/feature-flags/effective');
  },
};
